import React, { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { scrollToSeaMossChoice } from "../lib/plainGoldCart";
import { lookupPlainBasePriceGbp } from "../lib/pricing";
import { useShellTheme } from "./layout/ShellTheme";

const MobileStickyBar = () => {
  const { count, subtotal, setOpen, open } = useCart();
  const [show, setShow] = useState(false);
  const fromPrice = Math.min(
    lookupPlainBasePriceGbp("gold", 300, "pouch"),
    lookupPlainBasePriceGbp("purple", 300, "pouch")
  );
  const dark = useShellTheme() === "dark";

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 220);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (open || !show) return null;

  const wrap = "lg:hidden fixed inset-x-3 z-30 pointer-events-none";
  const wrapStyle = { bottom: "max(0.75rem, env(safe-area-inset-bottom, 0px))" };

  if (count > 0) {
    return (
      <div data-testid="mobile-sticky-checkout" className={wrap} style={wrapStyle}>
        <button
          onClick={() => setOpen(true)}
          className={
            dark
              ? "pointer-events-auto w-full flex items-center justify-between gap-3 rounded-full bg-gold text-void pl-5 pr-2 py-2 shadow-[0_16px_40px_-16px_rgba(199,168,109,0.55)]"
              : "pointer-events-auto w-full flex items-center justify-between gap-3 rounded-full bg-forest text-cream pl-5 pr-2 py-2 shadow-hover"
          }
        >
          <div className="flex items-center gap-3">
            <span
              className={`w-9 h-9 rounded-full grid place-items-center text-xs font-semibold ${
                dark ? "bg-void text-gold" : "bg-gold text-forest"
              }`}
            >
              {count}
            </span>
            <span className="text-sm">View basket</span>
          </div>
          <span
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium ${
              dark ? "bg-void text-ivory" : "bg-gold text-forest"
            }`}
          >
            £{subtotal.toFixed(2)}
            <ShoppingBag className="w-4 h-4" strokeWidth={1.6} />
          </span>
        </button>
      </div>
    );
  }

  return (
    <div data-testid="mobile-sticky-buy" className={wrap} style={wrapStyle}>
      <button
        type="button"
        onClick={() => scrollToSeaMossChoice()}
        className={
          dark
            ? "pointer-events-auto w-full flex items-center justify-between gap-3 rounded-full bg-gold text-void pl-5 pr-2 py-2 shadow-[0_16px_40px_-16px_rgba(199,168,109,0.55)] min-h-[52px]"
            : "pointer-events-auto w-full flex items-center justify-between gap-3 rounded-full bg-forest text-cream pl-5 pr-2 py-2 shadow-hover min-h-[52px]"
        }
      >
        <span className="text-sm font-semibold pl-1 tracking-wide uppercase truncate">Choose sea moss</span>
        <span
          className={`inline-flex items-center rounded-full px-4 py-2 text-sm font-medium ${
            dark ? "bg-void text-ivory" : "bg-gold text-forest"
          }`}
        >
          from £{fromPrice.toFixed(2)}
        </span>
      </button>
    </div>
  );
};

export default MobileStickyBar;
